import { render, staticRenderFns } from "./cusFooter.vue?vue&type=template&id=6f3af982&scoped=true&"
import script from "./cusFooter.vue?vue&type=script&lang=js&"
export * from "./cusFooter.vue?vue&type=script&lang=js&"
import style0 from "./cusFooter.vue?vue&type=style&index=0&id=6f3af982&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3af982",
  null
  
)

export default component.exports